import * as css from './emailScreen/EmailScreen.css';
import {useSelector} from 'react-redux';
import {updateDesignEmail} from '../../redux/branding/brandingActions';
import {defaultImage} from '../../assets/symbols/images/defaultImage';
import EyeHideSection from '../components/eyeHideSection/EyeHideSection';
import ConvertDecimalToHex from '../../functions/ConvertDecimalToHex';
import {givechakImage, givechakLogo} from '../../assets/symbols/images/givechakImage';
import ExternalImagePopup from '../../component/imagePopup/externalImagePopup/ExternalImagePopup';
import {useBrandingParams} from '../../hooks/useBrandingParams';
import {TState} from '../../redux/store.type';
import {MESSAGE_TYPES} from './menu/brandingConfig';

function EmailImage({name, eyeName='image'}) {
    const {messageType} = useBrandingParams();
    const {lang: defaultLang, type} = useSelector((s: TState) => s.event);
    const {colorMain} = useSelector((s: TState) => s.branding.data?.[s.branding.currentLang]??{});
    let {fbImg} = useSelector((s: TState) => s.event);
    const data = useSelector((s: TState) => s.branding?.data?.[s.branding.currentLang]??s.branding?.data?.[defaultLang]) || {};
    const widthWindowWidth=useSelector((s:TState) => s.ui.windowWidth);
    const imageHeight=Math.min(Math.floor((widthWindowWidth-20)/3.94),160);
    
    let {image, imageId, imageCredit} =  data?.[messageType]??{};
    if(!image) {
        image = data?.[MESSAGE_TYPES.sendTicket]?.image;
        imageId = data?.[MESSAGE_TYPES.sendTicket]?.imageId;
        imageCredit = data?.[MESSAGE_TYPES.sendTicket]?.imageCredit;
    }
    const hexColor = colorMain && ConvertDecimalToHex(colorMain);
    
    if((fbImg === defaultImage || fbImg === givechakLogo) && type=== 'givechak'){
        fbImg = givechakImage;
    }

    const imageEditorProps = {
        size: {width: Math.min(630,widthWindowWidth-20), height:imageHeight},
        image: image,
        imageId: imageId,
        setImage: (newImage) => updateDesignEmail(messageType, {[name]: newImage}),
    };
    
    return (
        <EyeHideSection sectionName={eyeName}>
            <css.emailImage color={hexColor} height={`${imageHeight}px`} data-cy={`${name}Image`}>
                {!image && <css.image className={type} image={fbImg|| (type=== 'givechak' ? givechakImage : defaultImage)}/>}
                <ExternalImagePopup imageProps={imageEditorProps} creditProps={imageCredit} absoluteImage={!image}/>
                <css.uploadIcon/>
            </css.emailImage>
        </EyeHideSection>
    );
}

export default EmailImage;
